import { render, staticRenderFns } from "./lanmao-alert.vue?vue&type=template&id=f12fbfb4&scoped=true&"
import script from "./lanmao-alert.vue?vue&type=script&lang=js&"
export * from "./lanmao-alert.vue?vue&type=script&lang=js&"
import style0 from "./lanmao-alert.vue?vue&type=style&index=0&id=f12fbfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12fbfb4",
  null
  
)

export default component.exports